import React, { useState } from "react";
import IconComponent from "../Icons/IconComponent";
import ButtonSkaRound from "../Buttons/ButtonSkaRound";

const CardDecisionTree = ({
    branch,
    levelIndex,
    selectedCard,
    accessrights,
    compactMode,
    onFindBranchById,
    selectBranch,
    onCreateNewBranch,
    onEditBranch,
    onDeleteBranch,
    decisionTree,
    setDecisionTree,
    setHasChange
}) => {

    const [draggingItem, setDraggingItem] = useState(null);

    const selected = selectedCard && selectedCard.branch.id === branch.id;

    const design = {
        color: "var(--carbone)",
        border: "1px solid var(--grey-light)",
        backgroundColor: "var(--grey-lighter)"
    };
    switch (levelIndex) {
        case 0:
            design.color = "var(--primary-base)";
            design.border = "1px solid var(--primary-base)";
            design.backgroundColor = "var(--primary-light)";
            break;
        case 1:
            design.color = "var(--carbone)";
            design.border = "1px solid var(--grey-light)";
            design.backgroundColor = "var(--grey-lighter)";
            break;
        case 2:
            design.color = "var(--carbone)";
            design.border = "1px solid var(--grey-light)";
            design.backgroundColor = "var(--white)";
            break;
    }

    const handleDrop = (e) => {
        e.stopPropagation();
        if (!draggingItem) {return;}

        if (draggingItem.levelIndex === levelIndex && branch.id !== draggingItem.branch.id) {
            const newDraggingPosition = branch.position;
            const newBranchPosition = draggingItem.branch.position;

            const tempTree = { ...decisionTree };
            const tempBranch = onFindBranchById(tempTree, branch.id);
            const tempDraggingBranch = onFindBranchById(tempTree, draggingItem.branch.id);

            tempBranch.position = newBranchPosition;
            tempDraggingBranch.position = newDraggingPosition;

            setDecisionTree(tempTree);
            setDraggingItem(null);
            setHasChange(true);
        }
        else {
            setDraggingItem(null);
        }
    };

    const handleDragStart = (e) => {
        setDraggingItem({ branch, levelIndex });
        e.dataTransfer.setData("text/plain", "");
    };

    const handleDragEnd = () => {
        setDraggingItem(null);
    };

    return <>
        { levelIndex === 0 || !compactMode || branch.show ?
            <>
                <div className="horizontalFlexContainer" style={{ width: "100%" }}
                    onDragOver={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                    onDragEnter={(e) => {
                        e.stopPropagation();
                    }}
                    onDrop={handleDrop}
                >
                    {
                        levelIndex > 0 ? <span style={{ width: "30px" }}/> : null
                    }
                    {
                        levelIndex > 1 ? <>
                            <span style={{ width: "30px" }}/>
                            <IconComponent dimensions="20" nameIcon="indentationGreyLight"/>
                            <span style={{ width: "10px" }}/>
                        </> : null
                    }
                    <div
                        className={`DecisionTreeBranchCardContainer horizontalFlexContainer ${
                            draggingItem && branch === draggingItem.branch && levelIndex === draggingItem.levelIndex ? "dragging" : ""
                        }`}
                        style={{ width: "auto", border: design.border, color: design.color, backgroundColor: design.backgroundColor }}
                        onClick={() => selectBranch(branch, levelIndex)}
                        key={branch.id}
                        draggable={accessrights && accessrights.hasPermission(70, "modify") > 10 && ( draggingItem === null || draggingItem.levelIndex === levelIndex ) ? true : false}
                        onDragStart={handleDragStart}
                        onDragEnd={handleDragEnd}
                    >
                        <span style={{ width: "10px" }}/>
                        <img src="/icons/other/Handle.svg"/>
                        <span style={{ width: "10px" }}/>
                        <div className="TextContent16" style={{ fontWeight: "400", color: design.color }}>
                            {branch.name}
                        </div>
                        {levelIndex < 2 && branch.branches.length <= 0 ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="4"
                                fill="red"
                            />
                        </svg> : null}
                        <span style={{ flexGrow: "1" }}/>
                        <div style={{ display: "flex", gap: "10px" }}>
                            { accessrights && accessrights.hasPermission(70, "modify") > 10 && levelIndex < 2 ?
                                <ButtonSkaRound
                                    type="secondary"
                                    onClick={() => {onCreateNewBranch(levelIndex + 1, branch.id);}}
                                    nameIcon="add"
                                />
                                : null
                            }
                            <ButtonSkaRound
                                type="secondary"
                                onClick={() => {onEditBranch(branch, levelIndex);}}
                                nameIcon="edit"
                            />
                            {accessrights && accessrights.hasPermission(70, "modify") > 10 ?
                                <ButtonSkaRound
                                    type="secondary"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDeleteBranch(branch, levelIndex);
                                    }}
                                    nameIcon="trash"
                                />
                                : null
                            }
                            <span style={{ width: "10px" }}/>
                        </div>
                    </div>
                </div>
                {branch.branches
                    && branch.branches
                        .sort((a, b) => a.position - b.position)
                        .map((el) =>
                            <CardDecisionTree
                                key={el.id}
                                branch={el}
                                levelIndex={levelIndex + 1}
                                compactMode={compactMode}
                                selectedCard={selectedCard}
                                accessrights={accessrights}
                                decisionTree={decisionTree}
                                setDecisionTree={setDecisionTree}
                                setHasChange={setHasChange}
                                onFindBranchById={onFindBranchById}
                                selectBranch={selectBranch}
                                onCreateNewBranch={onCreateNewBranch}
                                onEditBranch={onEditBranch}
                                onDeleteBranch={onDeleteBranch}
                            />
                        )}
            </> : null
        }
    </>;
};

export default CardDecisionTree;
